function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M29.568 14.922a1.56 1.56 0 010 2.155L18.312 28.703a.962.962 0 01-1.392 0l-.774-.8a1.04 1.04 0 010-1.437l8.633-8.916H3a1 1 0 01-1-1v-1.098a1 1 0 011-1h21.78l-8.634-8.916a1.04 1.04 0 010-1.437l.774-.8a.962.962 0 011.392 0l11.256 11.624z",
  fill: "currentColor"
})));